export enum RoutePaths {
  HOME = "/",
  ABOUT_US = "/about-us/",
  SERVICES = "/services/",
  PROJECTS = "/projects/",
  TOOLS = "/tools/",
  BLOGS = "/blogs/",
  CONTACTS = "/contacts/",
  PRIVACY_POLICY = "/privacy-policy/",
}
